import React, {useEffect} from 'react';
import * as S from './PeriodBody.styles';
import classnames from 'classnames';
import {Footer} from '../Footer';

export const PeriodBody = ({
  data,
  updatePeriodData,
  periodData,
  classes,
  onPeriodSelectCb,
  onDownloadClickCb,
  sendTrackingDataToSdk,
}) => {
  if (!data || !Array.isArray(data)) {
    return null;
  }
  useEffect(() => {
    if (!periodData?.id) {
      updatePeriodData(data?.[0]);
    }
  }, []);

  const renderTabList = () => {
    return data.map(({primaryText, secondaryText, id}, index) => {
      return (
        <li
          className={`tab ${id === periodData?.id ? 'active' : ''}`}
          key={id}
          onClick={() => {
            onPeriodSelectCb(data[index]);
          }}
        >
          <div>
            {primaryText}
            <p className="date">
              {secondaryText[0] && <span>{secondaryText[0]}</span>}

              {secondaryText[1] && (
                <React.Fragment>
                  <span className={classnames(classes)} />

                  <span>{secondaryText[1]}</span>
                </React.Fragment>
              )}
            </p>
          </div>
        </li>
      );
    });
  };

  const onClickCb = actions => {
    actions.forEach(action => {
      if (action?.type === 'API_CALL') {
        const startDate = periodData?.startDate;
        const endDate = periodData?.endDate;
        const downloadUrl = `${action?.api?.url}start_date=${startDate}&last_date=${endDate}`;
        onDownloadClickCb();
        window.open(downloadUrl, '_blank');
      }
    });
    sendTrackingDataToSdk?.(
      {
        event_detail: {
          event_name: 'click',
          event_type: 'user_action',
          event_value: 'DownloadCommissionClicked',
        },
      },
      'COMMISSION_REPORT',
    );
  };
  const renderTabListBody = () => {
    return data.map(({id, body = {}}, index) => {
      if (id !== periodData?.id) {
        return null;
      }
      const {
        left: {primaryText = '', primarySubText = '', secondaryText = '', infoText = ''},
        right = {},
      } = body;

      return (
        <div className="tabContent" key={index + id}>
          <div className="commEarningData">
            <p className="comEarning">
              {primaryText} <span>{primarySubText}</span>
            </p>
            <p className="totalPrice" dangerouslySetInnerHTML={{__html: secondaryText}}></p>
            <div dangerouslySetInnerHTML={{__html: infoText}}></div>
          </div>

          <div className="commEarningAction">
            <p className="btnLabel">{right?.primaryText}</p>
            <Footer
              data={right?.ctas}
              onClickCb={onClickCb}
              padding={'10px 53px'}
              isFooterDisabled={periodData?.downloadDisabled}
            ></Footer>
          </div>
        </div>
      );
    });
  };
  return (
    <S.CommEarningContainer>
      <ul className="tabList">{renderTabList()}</ul>
      {renderTabListBody()}
    </S.CommEarningContainer>
  );
};
